import React, { useEffect, useState } from "react";
import { StatusOptions } from "@/utils/constants/constants";
import { useDataQueries } from "@/utils/hooks/useDataQueries";
import EnvelopeTable from "@/components/tables/EnvelopeTable";
import TableHead from "@/components/tables/TableHead";
import { fetchFormEnvos } from "@/services/form.service";

interface FormEnvelopeProps {
    id: string
}

const FormEnvelopes = (props: FormEnvelopeProps) => {
    const [isLoading, setIsLoading] = useState(false);
    const [envelopes, setEnvelopes] = useState<any>([]);
    const [envelopesLeft, setEnvelopesLeft] = useState(true);
    const [envelopesHistory, setEnvelopesHistory] = useState<any>([]);
    const [allFetched, setAllFetched] = useState(false);
    const [loadData, setLoadData] = useState(true);
    const [totalCount, setTotalCount] = useState(0);

    const [pageNo, setPageNo, dataLength, setDataLength, sorting, setSorting, filter, setFilter, searchItem, setSearchItem, resetDataQueries] = useDataQueries();

    const handleFetchAllEnvos = () => {
        fetchFormEnvos(props.id, pageNo, dataLength, sorting, filter, searchItem,
            (response: any) => {
                setLoadData(false); setIsLoading(false); setTotalCount(response.data.total_count);
                if (response.data?.envelopes?.length < dataLength) { setEnvelopesLeft(false); setAllFetched(true); }
                const envs = response.data.envelopes;
                setEnvelopes(envs); setEnvelopesHistory(envs);
            },
            (error: any) => { console.log(error); setLoadData(false); setIsLoading(false); }
        );
    };

    useEffect(() => {
        setLoadData(true); setEnvelopesLeft(true); setAllFetched(false); handleFetchAllEnvos();
    }, [dataLength, sorting, searchItem]);

    window.onscroll = function () {
        if (allFetched || isLoading) return;
        if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 1) {
            setPageNo(pageNo + 1); setIsLoading(true);
            if (envelopesLeft) {
                fetchFormEnvos(props.id, pageNo + 1, dataLength, sorting, filter, searchItem,
                    (response: any) => {
                        setIsLoading(false); setTotalCount(response.data.total_count);
                        if (response.data?.envelopes?.length < dataLength) { setEnvelopesLeft(false); setAllFetched(true); }
                        setEnvelopes([...envelopes, ...response.data.envelopes]);
                        setEnvelopesHistory([...envelopes, ...response.data.envelopes]);
                    },
                    (error: any) => { console.log(error); setIsLoading(false); }
                );
            }
        }
    };

    const search = (searchText: string) => setSearchItem(searchText);
    const resetResponse = () => { setEnvelopesLeft(true); setAllFetched(false); };
    const reset = () => { resetDataQueries?.(); resetResponse(); };
    const handleApplyFilter = () => {
        setPageNo(1);
        resetResponse();
        setLoadData(true);
        setIsLoading(true);
        fetchFormEnvos(
            props.id,
            1,
            dataLength,
            sorting,
            filter,
            searchItem,
            (response: any) => {
                setLoadData(false);
                setIsLoading(false);
                setTotalCount(response.data.total_count);
                if (response.data?.envelopes?.length < dataLength) {
                    setEnvelopesLeft(false);
                    setAllFetched(true);
                }
                setEnvelopes(response.data.envelopes);
                setEnvelopesHistory(response.data.envelopes);
            },
            (error: any) => {
                console.log(error);
                setLoadData(false);
                setIsLoading(false);
            }
        );
    };

    return (
        <div className="gs-list-page-card">
            <div className="gs-list-page-card-header">
                <TableHead id='envelope-table' handleReset={resetResponse} pageNo={pageNo as number} dataLength={dataLength as number} setFilter={setFilter} filter={filter} setDataLength={setDataLength as (dataLength: number) => void} reset={reset} search={search} title="Envelopes" options={StatusOptions} handleApplyFilter={handleApplyFilter} currentEnvo={envelopes.length} totalEnvo={totalCount} />
            </div>
            <EnvelopeTable
                id='envelope-table'
                reset={reset}
                title="Envelopes"
                setEnvelopes={setEnvelopes}
                search={search}
                isLoading={isLoading}
                dataLength={dataLength as number}
                sorting={sorting}
                setSorting={setSorting as (sorting: any) => void}
                searchItem={searchItem as string}
                allFetched={allFetched}
                envelopes={envelopes}
                dataLoad={loadData}
                resetDataQueries={resetDataQueries}
                setPageNo={setPageNo}
            />
        </div>
    );
};

export default FormEnvelopes;
